<template>
  <div class="estimate-comparison-analysis">
    <div class="header">
      <div class="header-left">
        <div v-for="(item, index) in form" :key="index">
          <label>{{ item.label }}</label>
          <el-select
            v-model="item.value"
            placeholder="请选择"
            style="width: 250px"
            size="mini"
            @change="value => handleSelect(value, item, index)"
          >
            <el-option
              v-for="item in item.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <el-button type="primary" size="mini" @click="handleReport"
        >生成报表</el-button
      >
    </div>

    <SimpleTable
      ref="centerTable"
      table-code="estimateComparisonAnalysisCenter"
      :showIndex="false"
      :columns="columns.center"
      :data="tableData.center"
      :loading="loading.center"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import {
  sortRecords,
  dfsFn,
  listToTree,
  addCbFn,
  imgColumn
} from '@/utils/index'
import { get } from '@visactor/vtable/es/themes'

export default {
  name: 'EstimateComparisonAnalysis',
  components: {
    SimpleTable
  },
  data() {
    return {
      form: [
        {
          label: '估算名称',
          options: [],
          value: null
        },
        {
          label: '概算名称',
          options: [],
          value: null
        },
        {
          label: '施工预算',
          options: [],
          value: null
        }
      ],
      // 页面数据
      columns: {
        top: [
          {
            field: '_checkbox',
            title: '',
            width: 30,
            cellType: 'checkbox',
            headerType: 'checkbox',
            multiple: true,
            style: {
              textAlign: 'center',
              fontSize: 14
            },
            canEdit: true,
            headerStyle: {
              bgColor: '#f2f2f2',
              fontSize: 14,
              color: '#333333',
              fontWeight: 'bold',
              textAlign: 'center'
            }
          },
          { field: 'name', title: '方案名称' },
          {
            field: 'resultPictureFileUrl',
            title: '效果图',
            width: 50,
            ...imgColumn('resultPictureFileUrl')
          },
          { field: 'projectName', title: '项目名称' },
          { field: 'regionName', title: '所在区域' },
          { field: 'address', title: '详细地址' },
          { field: 'measurementUnit', title: '计量单位' },
          { field: 'constructionScale', title: '建筑规模' },
          { field: 'estimateAmount', title: '估算金额' },
          { field: 'costIndicator', title: '造价指标' },
          { field: 'breakEvenPoint', title: '盈亏平衡点' },
          { field: 'profitCycle', title: '盈利周期' },
          {
            field: 'order',
            title: '顺序',
            fieldType: 'number',
            scale: 0,
            canEdit: true
          }
        ],
        center: [{ field: 'name', title: '估算项目' }],
        bottom: [
          { field: 'name', title: '年月' },
          { field: 'name', title: '月度估算成本' },
          { field: 'name', title: '月度估算收入' },
          { field: 'name', title: '月度净流入' },
          { field: 'name', title: '累计净流入' },
          { field: 'name', title: '月度估算成本' }
        ]
      },
      tableData: {
        top: [],
        center: [],
        bottom: []
      },
      loading: {
        top: false,
        center: false,
        bottom: false
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    init() {
      this.getOptions()
    },

    async getOptions() {
      this.form[0].options = await this.getEstimateOptions()
      this.form[1].options = await this.getPreliminaryOptions()
      this.form[2].options = await this.getConstructionOptions()
    },

    // 获取估算方案选项
    async getEstimateOptions() {
      const res = await this.$service.get('/plan-investment-estimate/list', {})
      return sortRecords(res.data || [])
    },

    // 获取概算方案选项
    async getPreliminaryOptions() {
      const res = await this.$service.get('/design-budget-estimate/list', {})
      return sortRecords(res.data || [])
    },

    // 施工总预算
    async getConstructionOptions() {
      const res = await this.$service.get(
        '/construction-budget-estimate/list',
        {}
      )
      return sortRecords(res.data || [])
    },

    handleSelect(value, item, index) {
      if (index === 1) {
        const obj = item.options.find(e => e.id === value)
        this.form[0].value = obj.pieId
      } else if (index === 2) {
        const obj = item.options.find(e => e.id === value)
        this.form[1].value = obj.dbeId
        this.handleSelect(this.form[1].value, this.form[1], 1)
      }
    },

    async handleReport() {
      const arr = this.form.map(e => e.value)
      this.loading.center = true
      const res = await this.$service.post('/report/investment', {
        ids: arr,
        showDetail: true
      })
      this.loading.center = false
      if (res.code === 200) {
        dfsFn(
          res?.data?.columnList.filter((e, i) => i !== 0),
          e => (e.style = { textAlign: 'right' })
        )
        this.columns.center = res?.data?.columnList || []
        dfsFn(this.columns.center, e => (e.columns = e.children))
        if (this.columns.center[0]) this.columns.center[0].tree = true

        this.tableData.center = listToTree(res?.data?.dataList || [], -1)
      }
    },

    async handlesave() {}
  }
}
</script>

<style scoped>
.estimate-comparison-analysis {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    .header-left {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
    }
  }
}
</style>
